import apiFetch from '../apiFetch'

export default function (documentTypeUse, token) {
  return apiFetch({ endPoint: `document/${documentTypeUse}`, method: 'GET', token: token })
}
